import React from 'react'

export const Logo = ({logo = {}}) => logo.content ? <img src={'data:'+logo.mimeType+';base64,'+logo.content} alt={logo.fileName} width="200" /> : null
